import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { Observable } from 'rxjs';
import { ApiUrls } from '../backoffice-urls';

@Injectable({
  providedIn: 'root'
})
export class SharedocumentsService {
  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(@Inject(EnvConfig) private config: Environment) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  shareDocument(payload: any): Observable<any> {
    const url = this.apiUrl + ApiUrls.ShareDocument.shareDoc;
    return this.http.post<any>(url, payload);
  }

  getDocSharedByUserWithME(): Observable<any> {
    const url = this.apiUrl + ApiUrls.ShareDocument.getDocSharedByUserWithME;
    return this.http.get<any>(url);
  }

  getDocSharedByMe(): Observable<any> {
    const url = this.apiUrl + ApiUrls.ShareDocument.getDocSharedByMe;
    return this.http.get<any>(url);
  }

  Unshare(payload: any): Observable<any> {
    const url = this.apiUrl + ApiUrls.ShareDocument.unshare;
    return this.http.post<any>(url, payload);
  }
}
